function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import withRegistration from "../../lib/withRegistration";
import withEvents from "../../lib/withEvents";
var mapboxSourceProps = {
  sourceId: {
    type: String,
    required: true
  },
  source: {
    type: [Object, String],
    default: undefined
  }
};
var mapboxLayerStyleProps = {
  layerId: {
    type: String,
    required: true
  },
  layer: {
    type: Object,
    required: true
  },
  before: {
    type: String,
    default: undefined
  }
};
var componentProps = {
  clearSource: {
    type: Boolean,
    default: true
  },
  replaceSource: {
    type: Boolean,
    default: false
  },
  replace: {
    type: Boolean,
    default: false
  }
};
export default {
  mixins: [withEvents],
  props: _objectSpread(_objectSpread(_objectSpread({}, mapboxSourceProps), mapboxLayerStyleProps), componentProps),
  inject: ["mapbox", "map"],
  data: function data() {
    return {
      initial: true
    };
  },
  computed: {
    sourceLoaded: function sourceLoaded() {
      return this.map ? this.map.isSourceLoaded(this.sourceId) : false;
    },
    mapLayer: function mapLayer() {
      return this.map ? this.map.getLayer(this.layerId) : null;
    },
    mapSource: function mapSource() {
      return this.map ? this.map.getSource(this.sourceId) : null;
    }
  },
  created: function created() {
    if (this.layer.minzoom) {
      this.$watch("layer.minzoom", function (next) {
        if (this.initial) return;
        this.map.setLayerZoomRange(this.layerId, next, this.layer.maxzoom);
      });
    }

    if (this.layer.maxzoom) {
      this.$watch("layer.maxzoom", function (next) {
        if (this.initial) return;
        this.map.setLayerZoomRange(this.layerId, this.layer.minzoom, next);
      });
    }

    if (this.layer.paint) {
      this.$watch("layer.paint", function (next) {
        if (this.initial) return;

        if (next) {
          for (var _i = 0, _Object$keys = Object.keys(next); _i < _Object$keys.length; _i++) {
            var prop = _Object$keys[_i];
            this.map.setPaintProperty(this.layerId, prop, next[prop]);
          }
        }
      }, {
        deep: true
      });
    }

    if (this.layer.layout) {
      this.$watch("layer.layout", function (next) {
        if (this.initial) return;

        if (next) {
          for (var _i2 = 0, _Object$keys2 = Object.keys(next); _i2 < _Object$keys2.length; _i2++) {
            var prop = _Object$keys2[_i2];
            this.map.setLayoutProperty(this.layerId, prop, next[prop]);
          }
        }
      }, {
        deep: true
      });
    }

    if (this.layer.filter) {
      this.$watch("layer.filter", function (next) {
        if (this.initial) return;
        this.map.setFilter(this.layerId, next);
      }, {
        deep: true
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.map && this.map.loaded()) {
      try {
        this.map.removeLayer(this.layerId);
      } catch (err) {
        this.$_emitEvent("layer-does-not-exist", {
          layerId: this.sourceId,
          error: err
        });
      }

      if (this.clearSource) {
        try {
          this.map.removeSource(this.sourceId);
        } catch (err) {
          this.$_emitEvent("source-does-not-exist", {
            sourceId: this.sourceId,
            error: err
          });
        }
      }
    }
  },
  methods: {
    $_emitLayerMapEvent: function $_emitLayerMapEvent(event) {
      return this.$_emitMapEvent(event, {
        layerId: this.layerId
      });
    },
    $_bindLayerEvents: function $_bindLayerEvents(events) {
      var _this = this;

      Object.keys(this.$listeners).forEach(function (eventName) {
        if (events.includes(eventName)) {
          _this.map.on(eventName, _this.layerId, _this.$_emitLayerMapEvent);
        }
      });
    },
    $_unbindEvents: function $_unbindEvents(events) {
      var _this2 = this;

      if (this.map) {
        events.forEach(function (eventName) {
          _this2.map.off(eventName, _this2.layerId, _this2.$_emitLayerMapEvent);
        });
      }
    },
    $_watchSourceLoading: function $_watchSourceLoading(data) {
      if (data.dataType === "source" && data.sourceId === this.sourceId) {
        this.$_emitEvent("layer-source-loading", {
          sourceId: this.sourceId
        });
        this.map.off("dataloading", this.$_watchSourceLoading);
      }
    },
    move: function move(beforeId) {
      this.map.moveLayer(this.layerId, beforeId);
      this.$_emitEvent("layer-moved", {
        layerId: this.layerId,
        beforeId: beforeId
      });
    },
    remove: function remove() {
      this.map.removeLayer(this.layerId);
      this.map.removeSource(this.sourceId);
      this.$_emitEvent("layer-removed", {
        layerId: this.layerId
      });
      this.$destroy();
    }
  },
  render: function render() {}
};